export const leadSources = [
  { value: '', label: 'All' },
  { value: 'CALENDLY', label: 'Calendly' },
  { value: 'WEBSITE', label: 'Website' },
  { value: 'ADVERTISEMENT', label: 'Advertisement' },
  { value: 'WORD_OF_MOUTH', label: 'Word of Mouth' },
  { value: 'EMPLOYEE_REFERREL', label: 'Employee Referral' },
  { value: 'COLD_CALL', label: 'Cold Call' },
  { value: 'OTHER', label: 'Other' },
];

export const refer = leadSources.filter((item) => item.value !== '');

export const rankOptions = [
  { value: 'HOT', label: 'Hot' },
  { value: 'WARM', label: 'Warm' },
  { value: 'COLD', label: 'Cold' },
];

export const taskStatusOptions = [
  { value: 'TODO', label: 'To do' },
  { value: 'IN_PROGRESS', label: 'Doing' },
  { value: 'OVERDUE', label: 'Over Due' },
  { value: 'CLOSED', label: 'Closed' },
];

export const taskPriorityOptions = [
  { value: 'URGENT', label: 'Urgent' },
  { value: 'HIGH', label: 'High' },
  { value: 'NORMAL', label: 'Normal' },
  { value: 'LOW', label: 'Low' },
];
export const rankColorMap: Record<string, string> = {
  HOT: 'bg-red-100 text-red-800',
  WARM: 'bg-orange-100 text-[#C07322]',
  COLD: 'bg-primary-100 text-primary-800',
};

export const statusTextColorMap: Record<string, string> = {
  CLOSED: 'text-red-800',
  OVERDUE: 'text-red-800',
  IN_PROGRESS: 'text-green-800',
  TODO: 'text-yellow-800',
  URGENT: 'text-red-800',
  HIGH: 'text-yellow-800',
  NORMAL: 'text-[#42389D]',
  LOW: 'text-gray-900',
};

export const statusBgColorMap: Record<string, string> = {
  CLOSED: 'bg-red-100',
  OVERDUE: 'bg-red-100',
  URGENT: 'bg-red-100',
  IN_PROGRESS: 'bg-green-100',
  TODO: 'bg-yellow-100',
  HIGH: 'bg-yellow-100',
  NORMAL: 'bg-[#E5EDFF]',
  LOW: 'bg-gray-100',
};

export const leadStatusOptions = [
  { value: 'PENDING_APPROVAL', label: 'Pending approval' },
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'SUBMITTED', label: 'Submitted' },
  { value: 'RETURNED', label: 'Returned' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'WITHDRAWN', label: 'Withdrawn' },
  { value: 'ARCHIVED', label: 'Archived' },
];

export const invoiceStatusColorMap: Record<string, string> = {
  PARTIALLY_PAID: 'bg-primary-100 text-primary-1000',
  PAID: 'bg-green-100 text-green-500',
  OVER_DUE: 'bg-red-100 text-red-500',
  OPEN: 'bg-secondary-100 text-secondary-1000',
};

export const invoiceStatusOptions = [
  { value: 'PARTIALLY_PAID', label: 'Partially Paid' },
  { value: 'PAID', label: 'Paid' },
  { value: 'OVER_DUE', label: 'Over Due' },
  { value: 'OPEN', label: 'Open' },
];

export const programStatusOptions = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'IN_ACTIVE', label: 'Inactive' },
  { value: 'ARCHIVED', label: 'Archived' },
];

export const programStatusColorMap: Record<
  string,
  { text: string; bg: string }
> = {
  DRAFT: {
    text: 'text-gray-800 text-sm font-normal',
    bg: 'bg-gray-100',
  },
  ACTIVE: {
    text: 'text-green-500 text-sm font-normal',
    bg: 'bg-green-100',
  },
  IN_ACTIVE: {
    text: 'text-red-500 text-sm font-normal',
    bg: 'bg-red-100',
  },
  ARCHIVED: {
    text: 'text-[#6C757D] text-sm font-normal',
    bg: 'bg-[#F0F1F2]',
  },
};

export const LANGUAGE_LEVEL = [
  { value: 'BEGINNER', label: 'Beginner' },
  { value: 'LOWER_INTERMEDIATE', label: 'Lower intermediate' },
  { value: 'INTERMEDIATE', label: 'Intermediate' },
  { value: 'UPPER_INTERMEDIATE', label: 'Upper intermediate' },
  { value: 'ADVANCED', label: 'Advanced' },
];

export const userStatusOptions = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'IN_ACTIVE', label: 'Inactive' },
];

export const userStatusColorMap = {
  ACTIVE: {
    text: 'text-green-500 text-sm font-normal',
    bg: 'bg-green-100',
  },
  IN_ACTIVE: {
    text: 'text-red-500 text-sm font-normal',
    bg: 'bg-red-100',
  },
};
